/**
 * 财务中心 - 简体中文
 */
export default {
  title: '财务中心',
  accountBill: '账户账单',
  equityManagement: '权益管理',
  goldManagement: '金币管理',
  cashAccountManage: '现金账户',
  deliveryVoucherManage: '发货凭证',
  accountAssetsBoard: '账户资产看板',
  accountChange: '账户变动通知',
  accountBillTitle: '账户结算单',
  createAccountTogether: '总部共建账户',
  refundRecord: '退款记录',
  // 账户结算单
  settlementOrderNo: '结算单号',
  placeholderSettlementNo: '请输入结算单号',
  agentLabel: '代理商',
  placeholderAgent: '请选择代理商',
  accountType: '账户类型',
  placeholderAccountType: '请选择账户类型',
  itemType: '项目',
  placeholderItemType: '请选择项目',
  createTimeLabel: '创建时间',
  expenditureMethod: '支出/转移方式',
  placeholderSelect: '请选择',
  createByName: '创建人',
  placeholderCreateByName: '请输入创建人',
  settlementStatus: '结算状态',
  placeholderSettlementStatus: '请选择结算状态',
  settlementType: '结算类型',
  lastPayTime: '最后支出时间',
  transferAgent: '转入代理商',
  placeholderTransferAgent: '请选择转入代理商',
  transferAccountType: '转入账户类型',
  placeholderTransferAccountType: '请选择转入账户类型',
  placeholderContactFromInvoice: '自动从发票抬头获取，可修改',
  activityNameLabel: '活动名称',
  activityRegionLabel: '活动区域',
  placeholderActivityRegion: '请选择活动区域',
  regionOne: '区域一',
  regionTwo: '区域二',
  agentId: '代理商ID',
  agentName: '代理商名称',
  expenditureMethodName: '支出/转移方式',
  accountTypeName: '账户类型',
  itemTypeName: '项目',
  settlementAmount: '结算金额',
  receivedAmountLabel: '实付金额',
  receivedAmountCol: '实付金额',
  remarkLabel: '备注',
  attachment: '附件',
  transferAgentId: '转入代理商ID',
  transferAgentName: '转入代理商名称',
  transferAccountTypeName: '转入账户类型',
  transferItem: '转入项目',
  lastPayTimeLabel: '最后支付时间',
  createTimeCol: '创建时间',
  dateRangeSep: '~',
  // 账户变动通知
  accountChangeNotice: '账户变动通知',
  read: '阅读',
  changeTypeLabel: '账户变动类型',
  placeholderChangeType: '请选择类型',
  accountRecharge: '账户充值',
  accountExpenditure: '账户支出',
  accountTransfer: '账户转移',
  statusLabel: '状态',
  placeholderStatus: '请选择状态',
  unread: '未读',
  readStatus: '已读',
  sendTimeLabel: '发送时间',
  noticeContent: '通知内容',
  sendTimeCol: '发送时间',
  // 退款记录 RefoundRecord
  refundSummary: '共{count}笔流水，支付金额合计{money}元',
  orderNo: '订单编号',
  refundAmount: '退款金额',
  refundAccount: '退款账户',
  refundTime: '退款时间',
  refundType: '退款类型',
  refundBy: '退款人',
  placeholderRefundType: '请选择退款类型',
  placeholderRefundAccount: '请选择退款账户',
  placeholderRefundOrderNo: '请输入订单编号',
  getDataFailed: '获取失败',
  // 现金账户 CashAccountManage
  rechargeRecord: '充值记录',
  expenseRecord: '消费记录',
  withdrawRecord: '提现记录',
  transferCashRecord: '转现金账户记录',
  withdrawAccount: '提现账户',
  withdrawableAmount: '可提现金额：',
  loanType: '货款类',
  nonLoanType: '非货款类',
  applyWithdraw: '申请提现',
  transferToCashAccount: '转现金账户',
  loanBalance: '货款类余额: ',
  nonLoanBalance: '非货款类余额: ',
  inventoryCashValue: '存货现金价值：',
  cashYuan: '元',
  serialNo: '流水号',
  rechargeAmount: '充值金额',
  rechargeMethod: '充值方式',
  rechargeTime: '充值时间',
  operatorCol: '操作人',
  applySuccess: '申请成功！',
  applyFailed: '申请失败！',
  agentSubjectInvoiceTip: '您当前代理商主体非公司性质，请去"财务中心->发票->发票抬头维护"中，填写公司类型的申请，该申请由松鼠行政审核通过后再来申请提现。',
  transferSuccessTip: '提交成功，并已将该申请金额转移至现金账户！',
  withdrawBalanceTip: '因为提现账户的货款类余额不足，无法申请提现。',
  transferNoInvoiceTip: '因为提现账户的货款转现金账户，无需开票，自动审核确认，并已将该申请金额转移至现金账户！',
  // 提现记录 / 转现记录
  loanWithdrawAmount: '货款类提现金额：',
  nonLoanWithdrawAmount: '非货款类提现金额：',
  loanTransferTotal: '货款类转移金额合计：',
  nonLoanTransferTotal: '非货款转移金额合计：',
  withdrawOrderNo: '提现单号',
  withdrawAmount: '提现金额',
  withdrawTime: '提现时间',
  rechargeType: '充值类型',
  payee: '收款人姓名',
  depositBank: '收款银行',
  accountNumber: '收款账号',
  paymentTime: '打款时间',
  payer: '打款人',
  transferAmount: '转移金额',
  transferTime: '转移时间',
  applyStatus: '申请状态',
  // 提货券 DeliveryVoucherManage
  deliveryVoucher: '提货券',
  accountBalance: '账户余额：',
  myIssued: '我发放的提货券：',
  myReceived: '我收到的提货券：',
  myConsumed: '我消费的提货券：',
  myVerified: '我核销的提货券：',
  deliveryVoucherTabMyIssued: '我发放的提货券',
  deliveryVoucherTabMyReceived: '我收到的提货券',
  deliveryVoucherTabMyConsumed: '我消费的提货券',
  deliveryVoucherTabMyVerified: '我核销的提货券',
  // 金账户 GoldManagement
  serviceProviderRights: '服务商权益',
  goldExpenseRecord: '金账户消费记录',
  goldRechargeRecord: '金账户充值记录',
  goldAccount: '金账户',
  totalWithdrawAmount: '提货款总额：',
  paidWithdrawAmount: '已付提货款金额：',
  totalWithdrawAmountCol: '提货款总额',
  paidWithdrawAmountCol: '已付提货款金额',
  paidOrderTotalAmount: '已支付订单总金额：',
  retainAmountLabel: '保留货款金额：',
  // CashDataModal 支付弹窗
  bankAccountLabel: '银行账号：',
  openingBankLabel: '开户行：',
  transferAmountLabel: '转账金额：',
  payTimeLabel: '支付时间：',
  payTimeRequired: '支付时间不能为空',
  selectPayTime: '请选择支付时间：',
  paySerialNo: '支付流水',
  placeholderPaySerialNo: '请输入支付流水',
  payVoucherLabel: '支付凭证：',
  payVoucherRequired: '支付凭证不能为空',
  voucherTip: '支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB',
  voucherExample: '凭证实例',
  payRemarkLabel: '支付备注：',
  placeholderPayRemark: '请输入支付备注',
  clickUpload: '点击上传',
  paySuccess: '付款成功',
  payFailed: '付款失败',
  // 金账户充值 GoldReCharge
  rechargeNoLabel: '充值流水：',
  placeholderRechargeNo: '请输入充值流水',
  operatorPlaceholder: '操作人',
  rechargeTimeLabel: '充值时间：',
  rechargeMethodLabel: '充值方式：',
  // 金账户消费 GoldExpenseCalendar
  purchaseNo: '采购单号',
  purchaseNoLabel: '采购单号：',
  productName: '采购商品',
  purchaseNum: '采购数量',
  purchaseAmount: '采购金额',
  goldPayAmount: '金账户支付金额',
  voucherPayAmount: '裂变账户支付金额',
  cashPayAmount: '现金支付金额',
  paymentMethod: '支付方式',
  lastPayTimeCol: '最后支付时间',
  payTimeLabel: '支付时间：',
  // 申请提现弹窗 CashModel
  applyWithdrawTitle: '申请提现',
  withdrawAutoCalcTip: '根据所选充值类型，自动计算最高可提现金额',
  rechargeTypeLabel: '充值类型：',
  placeholderRechargeType: '充值类型',
  applyNoLabel: '申请单号：',
  applyNoAutoTip: '保存时自动产生，不可修改',
  applyWithdrawAmountLabel: '申请提现金额：',
  placeholderApplyWithdrawAmount: '申请提现金额',
  maxWithdrawAmountLabel: '最高可提现金额：',
  payeeNameLabel: '收款人姓名：',
  placeholderPayeeName: '请输入收款人姓名',
  openingBankExample: '例：中国工商银行江苏省南京市福建路支行',
  openingBankLabel: '开户银行：',
  placeholderOpeningBank: '须包括省市、总行及分/支行信息',
  accountNoLabel: '收款账号：',
  placeholderAccountNo: '请输入收款账号',
  contactPhoneLabel: '联系电话：',
  placeholderContactPhone: '自动从发票抬头获取，可修改',
  close: '关闭',
  confirm: '确认',
  noteLabel: '注',
  loanInvoiceRemindTitle: '货款开票提醒',
  applyNoShort: '申请单号',
  invoiceUnit: '开票单位',
  invoiceIndex: '发票',
  invoiceType: '发票类型',
  invoiceAmount: '开票金额',
  invoiceItem: '开票项目',
  loanInvoiceNote: '请优先提交松鼠开具的发票红冲，如无可红冲发票,则将现有未开票采购订单截图后,去"财务中心->代理商帐户->提现申请"中提交',
  gotIt: '我知道了',
  nonLoanInvoiceRemindTitle: '非货款开票提醒',
  nonLoanInvoiceNote: '请开票完成后，去"财务中心->代理商帐户->提现申请"中提交发票',
  selectRechargeType: '请选择充值类型',
  inputApplyWithdrawAmount: '请输入申请提现金额',
  withdrawInsufficientBalance: '提现账户余额不足！',
  inputContactPhone: '请输入联系电话',
  submitFailed: '提交失败',
  // 转现金账户 ChangeCashModel
  transferCashTitle: '转现金账户',
  applyAmountLabel: '申请金额：',
  placeholderApplyAmount: '请输入申请金额',
  maxApplyAmountLabel: '最高可申请金额：',
  inputTransferAmount: '请输入转现金账户金额',
  nonLoanInvoiceNoteTransfer: '请开票完成后，去"财务中心->代理商帐户->转现金账户申请"中提交发票',
  // 提货券列表（发放/收到/消费/核销）
  recordNoLabel: '流水号：',
  placeholderRecordNo: '流水号',
  purchaseOrderLabel: '采购订单：',
  placeholderPurchaseOrder: '采购订单',
  grantTimeLabel: '发放时间：',
  relatedAgentId: '关联代理商ID',
  relatedAgentName: '关联代理商名称',
  deliveryVoucherAmount: '提货券金额',
  grantAgentId: '发放代理商ID',
  grantAgentName: '发放代理商名称',
  purchaseOrder: '采购订单',
  grantTimeCol: '发放时间',
  grantBy: '发放人',
  belongAgentId: '归属代理商ID',
  belongAgentName: '归属代理商名称',
  receiveTime: '获得时间',
  consumeVoucherAmount: '消费提货券金额',
  consumeOrderNo: '消费订单号',
  consumeTime: '消费时间',
  consumeBy: '消费人',
  verifyAgentId: '核销代理商ID',
  verifyAgentName: '核销代理商名称',
  verifyAmount: '核销金额',
  verifyOrderNo: '核销订单',
  verifyTime: '核销时间',
  verifyBy: '核销人',
  // 提现/转现搜索与导出
  withdrawRecordExport: '提现记录导出',
  withdrawOrderNoLabel: '提现单号：',
  placeholderWithdrawOrderNo: '请输入提现单号',
  withdrawTimeLabel: '提现时间：',
  paymentTimeLabel: '打款时间：',
  applyStatusLabel: '申请状态：',
  placeholderApplyStatus: '请选择申请状态',
  transferTimeLabel: '转移时间：',
  transferAccountTypeLabel: '转移账户类型：',
  statusPendingSubmit: '待提交',
  statusPendingAudit: '待审核',
  statusReturned: '已退回',
  statusPendingPay: '待打款',
  statusCompleted: '已完成',
  statusCancelled: '已取消',
  // 支付流水 PaymentFlow
  paymentTotalLabel: '支付金额合计',
  rechargeId: '充值ID',
  rechargeIdLabel: '充值ID',
  placeholderRechargeId: '请输入充值ID',
  dataTypeName: '支付类型',
  payTimeCol: '支付时间',
  payMethodLabel: '支付方式：',
  payTimeLabelSearch: '支付时间',
  orderNoLabel: '采购单号',
  placeholderOrderNo: '请输入采购单号',
  expenditureMethodLabel: '支出方式：',
  itemTypeLabel: '项目：',
  // 转现金账户申请 ApplicationForCash
  applyOrderNo: '申请单号',
  applyAmount: '申请金额',
  applyTime: '申请时间',
  applicant: '申请人',
  auditTime: '审核时间',
  auditor: '审核人',
  auditRemark: '审核备注',
  contactPhone: '联系电话',
  placeholderContact: '请输入联系电话',
  placeholderApplyAmountCash: '请输入申请金额',
  invoiceUpload: '发票上传：',
  invoiceUploadMaxPdf: '最多上传5个pdf文件',
  noInvoiceData: '暂无发票信息',
  invoiceInfo: '开票信息：',
  submit: '提交',
  save: '保存',
  cancel: '取消',
  tip: '提示',
  confirmSubmitNoInvoice: '您未上传任何发票信息，是否确定提交总部财务审核？',
  confirmCancel: '确认取消吗？',
  inputContactRequired: '请输入联系方式',
  uploadFileTypeLimit: '只限上传png、jpg、jpeg、pdf类型文件',
  uploadFileSizeLimit: '最大可上传5M的文件',
  downloadFailed: '下载失败',
  operationSuccess: '操作成功',
  operationFailedRetry: '操作失败，请重试',
  noInvoiceWarning: '您未上传任务发票信息，不可提交总部财务审核，请上传发票后再提交！',
  applyOrderNoLabel: '申请单号',
  placeholderApplyOrderNo: '请输申请单号',
  applyTimeLabel: '申请时间',
  paymentTimeLabelApply: '打款时间',
  dateRangeTo: '至',
  rechargeTypeCol: '充值类型',
  submitInvoice: '提交发票',
  applyEdit: '修改',
  transferCashDetail: '转现金账户详情',
  transferCashSubmitInvoice: '转现金账户提交发票',
  transferCashEdit: '转现金账户修改',
  // 发票抬头 InvoiceHeader
  invoiceHeaderType: '发票抬头类型：',
  companyType: '公司',
  personalType: '个人',
  companyHeadLabel: '公司抬头：',
  placeholderCompanyHead: '请填写公司抬头',
  taxNoLabel: '税号：',
  placeholderTaxNo: '请填写税号',
  phoneLabel: '电话：',
  placeholderPhone: '请填写电话',
  addressLabel: '地址：',
  placeholderAddress: '请填写地址',
  placeholderOpeningBankFill: '请填写开户银行',
  placeholderBankAccountFill: '请填写银行账号',
  placeholderSelectInvoiceType: '请选择发票类型',
  emailLabel: '电子邮箱：',
  placeholderEmailFill: '请填写电子邮箱',
  businessLicenseLabel: '营业执照：',
  legalIdFrontLabel: '法人身份证正面：',
  legalIdBackLabel: '法人身份证反面：',
  clickUploadImage: '点击上传图片',
  previewFile: '预览文件',
  deleteFile: '删除文件',
  nameLabel: '姓名：',
  placeholderName: '请填写姓名',
  idCardLabel: '身份证号：',
  placeholderIdCard: '请填写身份证号',
  idCardFrontLabel: '身份证正面：',
  clickReuploadImage: '点击重新上传图片',
  requireCompanyHead: '请填写公司抬头',
  requireTaxNo: '请填写税号',
  requirePhone: '请填写电话',
  requireAddress: '请填写地址',
  requireOpeningBank: '请填写开户银行',
  requireBankAccount: '请填写银行账号',
  requireInvoiceType: '请选择发票类型',
  requireEmail: '请填写电子邮箱',
  requireName: '请填写姓名',
  requireIdCard: '请填写身份证号',
  applyWithdrawAmountLabel: '申请提现金额',
  inputContactPhone: '请输入联系电话',
  submitSuccess: '提交成功',
  saveSuccess: '保存成功',
  // 提现申请 RequestWithdrawal
  withdrawApplyDetail: '提现申请详情',
  withdrawApplySubmitInvoice: '提现申请提交发票',
  withdrawApplyEdit: '提现申请修改',
  cancelSuccess: '取消成功',
  cancelFailed: '取消失败',
  invoiceRedFlushTip: '请优先上传可红冲发票，如果没有可红冲发票，请上传未开票订单的截图，财务会根据提现金额扣减相应的订单开票金额！',
  // RequestWithdrawal 搜索与表格
  placeholderRechargeTypeSelect: '请选择充值类型',
  rechargeTypeGoods: '货款类',
  rechargeTypeNonGoods: '非货款类',
  placeholderApplyStatusSelect: '请选择申请状态',
  statusPendingSubmit: '待提交',
  statusPendingAudit: '待审核',
  statusReturned: '已退回',
  statusCancelled: '已取消',
  statusPendingPay: '待打款',
  statusCompleted: '已完成',
  placeholderPaymentTimeRange: '请选择打款时间范围',
  placeholderCreateTimeRange: '请选择申请时间范围',
  applyTypeNameCol: '申请类型',
  applyStatusValueCol: '申请状态',
  openingBankCol: '开户银行',
  bankAccountCol: '银行账号',
  mobileCol: '联系电话',
  submitTimeCol: '提交时间',
  createByNameCol: '申请人',
  auditUserNameCol: '审核人',
  remarkCol: '审核备注',
  paymentTimeCol: '打款时间',
  paymentUserNameCol: '打款人',
  // 服务商权益 ServiceProviderRights
  serviceArea: '服务区域',
  retainBalance: '应保留余额',
  statusShort: '状态',
  period: '周期',
  // 参访报销 VisitReimbursement
  reimbursementApply: '报销申请',
  expressNoCol: '快递单号',
  attachmentCol: '附件',
  viewAction: '查看',
  visitRecordCol: '参访记录',
  reimburseNo: '报销单号',
  placeholderReimburseNo: '请输入单号',
  applyAmountShort: '申请金额',
  confirmCancelReimburse: '确定取消该条报销吗？',
  viewAttachment: '查看附件',
  visitorName: '参访客户姓名',
  visitPhone: '参访客户手机',
  visitCampusId: '参访经销商ID',
  visitCampusName: '参访经销商名称',
  storeId: '门店ID',
  storeAddress: '参访门店地址',
  signTime: '签到时间',
  reimburseNoLabel: '报销单号',
  applyStatusShort: '申请状态',
  placeholderApplyStatusShort: '请选择状态',
  applyTimeShort: '申请时间',
  expressNoLabel: '快递单号',
  auditTimeShort: '审核时间',
  dateRangeToShort: '至',
  queryFailed: '查询失败',
  exportRefundListTitle: '退款记录列表导出',
  // 参访报销申请 VisitReimbursementApply
  back: '返回',
  agentLabelColon: '代理商：',
  reimburseNoColon: '报销单号：',
  createByLabel: '创建人：',
  reimburseTotalAmount: '报销总金额：',
  expressCompany: '快递公司：',
  expressPhoneLabel: '快递手机号：',
  placeholderExpressNo: '请输入快递单号',
  placeholderExpressPhone: '请输入快递手机号',
  invoiceMailAddress: '发票邮寄地址：',
  recipientInfo: '收件人信息：',
  noticeLabel: '注意：',
  reimburseMailTip: '请将报销的纸质发票邮寄到上述地址，并填写准确的快递单号，以便总部人员及时处理！',
  reimburseInvoiceUpload: '报销发票上传：',
  uploadPdfOrImageTip: '请上传pdf文件或者图片',
  selectVisitRecordBtn: '+请选择参访记录',
  deleteAction: '删除',
  saveBtn: '保存',
  selectVisitRecordTitle: '选择参访记录',
  confirmDeleteTip: '确认删除吗？',
  promptTitle: '提示',
  validateReimburseAmount: '请输入报销金额',
  validateExpressCompany: '请选择快递公司',
  validateExpressNo: '请填写快递单号',
  validateExpressPhone: '请填写快递手机号',
  onlyPdfImageTip: '只限上传pdf、png、jpg、jpeg类型文件',
  maxUploadSizeTip: '最大可上传20M的文件',
  deleteSuccess: '删除成功！',
  expressPhone11Tip: '请输入11位的快递手机号',
  pleaseUploadAttachment: '请先上传附件',
  pleaseSelectVisitRecord: '请先选择参访记录',
  pleaseCompleteReimburseForm: '请先完善报销申请表单',
  modifySuccess: '修改成功',
  // 权益管理 EquityManagement
  equityDescription: '权益描述',
  equityDetail: '详情',
  equityType: '权益类型',
  equityName: '权益名称',
  rightCode: '权益编码',
  equityForm: '权益形式',
  grantPerson: '发放人',
  grantTimeLabel: '发放时间',
  validityPeriod: '有效期',
  exclusiveAttr: '专有属性',
  placeholderEquityType: '请选择权益类型',
  placeholderEquityName: '请输入权益名称',
  placeholderRightCode: '请输入权益编码',
  placeholderEquityForm: '请选择权益形式',
  validUntilTime: '有效截止时间',
  equityDescriptionTitle: '权益描述',
  equityUsageDesc: '权益说明：',
  equityUsageMethod: '权益使用方法：',
  // 账户资产看板 AccountAssetsBoard
  boardDataCutoffTip: '此看板所有数据统计截止时间：',
  accountBalanceBoard: '账户余额',
  commonAccount: '通用账户',
  goldAccountShort: '金账户',
  cashAccountShort: '现金账户',
  fissionBonusAccount: '裂变奖金账户',
  withdrawAccountShort: '提现账户',
  createAccountTogetherShort: '总部共建账户',
  convertibleOptionAmount: '可兑换期权金额',
  promotionFee: '推广费',
  cityFee: '深扎城市费',
  deliveryVoucherAccountBoard: '提货券账户',
  deliveryVoucherBalance: '提货券账户余额',
  grantedDeliveryVoucher: '发放的提货券',
  verifiedDeliveryVoucher: '核销的提货券',
  dualOrderPendingReturn: '双重订单待返提货券',
  equipmentAssets: '设备资产',
  equipmentType: '设备类型',
  cashAmountCol: '现金金额',
  fissionAmount: '裂变金额',
  totalCol: '合计',
  orderAssets: '订单资产',
  purchaseOrderSection: '采购订单',
  undeliveredPurchaseTotal: '未发货采购订单总金额',
  undeliveredPurchaseCash: '未发货采购订单现金金额',
  undeliveredPurchaseFission: '未发货采购订单裂变金额',
  creditOrderUndeliveredTotal: '赊货订单未发货已支付总金额',
  creditOrderUndeliveredCash: '赊货订单未发货已支付现金金额',
  creditOrderUndeliveredFission: '赊货订单未发货已支付裂变金额',
  deliveryOrderSection: '发货订单',
  shippedUnpaidTotal: '已发货未回款订单总金额',
  shippedUnpaidCash: '已发货未回款现金金额',
  shippedUnpaidFission: '已发货未回款裂变金额',
  creditShippedUnpaidTotal: '赊货订单已发货未回款订单总金额',
  creditShippedUnpaidCash: '赊货订单已发货未回款现金金额',
  creditShippedUnpaidFission: '赊货订单已发货未回款裂变金额',
  noPermissionToPage: '您的账号没有进入该详情页面的权限！',
  // 代理商账户看板 AgentAccount/AccountBoard
  rechargeBtn: '充值',
  inventoryStockValue: '库存存货价值',
  includeFission: '含裂变',
  remainingUnordered: '剩余未下单金额',
  withdrawableLabel: '(可提现金额)',
  loanTypeYuan: '货款类',
  nonLoanTypeYuan: '非货款类',
  inventoryStockValueTipA: 'a、统计库存设备中，未软件激活的正价学习机商品对应采购订单采购单价合计;',
  inventoryStockValueTipB: 'b、亲子机、样机不统计;',
  transferToCashAccountTitle: '转现金账户',
  rechargeAmountLabel: '充值金额:',
  rechargeNow: '立即充值',
  // 流水汇总 CollectWater
  batchConfirm: '批量确认',
  batchBindOrder: '批量绑定订单',
  flowSummary: '共{count}笔流水，充值金额合计{money}元',
  financialConfirm: '财务确认',
  bindOrder: '绑定订单',
  paySysNo: '支付流水',
  transferAmountCol: '转出金额',
  rebateMonth: '返佣月份',
  flowStatus: '流水状态',
  confirmUser: '确认人',
  confirmTimeLabel: '确认时间',
  verifyRemarkCol: '确认备注',
  placeholderFlowStatus: '请选择流水状态',
  rechargeIdLabel: '充值ID',
  placeholderRechargeId: '请输入充值ID',
  statusConfirmed: '确认',
  flowStatusPendingConfirm: '待确认',
  statusReturned: '退回',
  placeholderConfirmUser: '请选择确认人',
  collectWaterPurchaseOrderNoLabel: '采购单号',
  placeholderCollectWaterPurchaseOrderNo: '请输入采购单号',
  // 权益详情 EquityDetails
  equityInfoTitle: '权益信息',
  writeOffInfoTitle: '核销信息',
  consNo: '核销单号',
  consTime: '核销时间',
  consType: '核销方式',
  belongCampus: '归属经销商',
  equityLevel: '权益等级',
  equityAmount: '权益金额',
  applicableProduct: '适用商品型号',
  equityDiscount: '权益折扣',
  marketingActivity: '参与的营销活动',
  activityPrice: '活动价',
  equityQty: '权益数量',
  // 双重订单余额 DoubleOrderBalance
  newDoubleOrder: '新建双重订单',
  doubleOrderInactiveTip: '该代理商账号尚未激活，是否继续下双重订单?',
  accountActivateTime: '账户激活时间',
  goldAccountBalance: '金帐户余额',
  cashAccountBalance: '现金帐户余额',
  deliveryVoucherBalanceShort: '提货券余额',
  daysToAutoOrder: '距离自动下单剩余天数',
  subAgentLabel: '下级代理商:',
  placeholderSelectAgent: '请选择代理商',
  confirmContinue: '继续',
  queryBalanceFail: '查询余额失败',
  // ReCharge 充值记录
  rechargeNoCol: '流水号',
  rechargeAmountCol: '充值金额',
  payMethodCol: '充值方式',
  payTimeColRecharge: '充值时间',
  accountTypeCol: '账户类型',
  createByColRecharge: '操作人',
  remarkColRecharge: '备注',
  operatorLabel: '操作人:',
  placeholderOperator: '操作人',

  // WithdrawalsRecord 提现记录
  withdrawalNoLabel: '提现单号:',
  placeholderWithdrawalNo: '请输入提现单号',
  withdrawalTimeLabel: '提现时间:',
  serialNoColWithdrawal: '流水号',
  payAmountWithdrawalCol: '提现金额',
  withdrawalTimeCol: '提现时间',
  withdrawalMethodCol: '提现方式',
  payAmountCol: '支付金额',
  purchaseOrderNoCol: '采购单号',
  purchaseQtyCol: '采购数量',
  purchaseAmountCol: '采购金额',
  purchaseQuantityCol: '采购数量',
  unitPriceCol: '单价',
  settlementOrderNoCol: '结算单号',
  expenditureMethodCol: '支出方式',
  createByNameCol: '操作人',
  refundTimeLabel: '支付时间:',
  valuationCol: '估值',

  // 样机指标查询 SampleIndexQuery
  sampleIndexHelpDesc: '关于样机指标的规则及解读',
  productTypeLabel: '商品类型',
  currentAvailableSampleIndicator: '当前可用样机指标',
  advanceIndicator: '(预支指标)',
  sampleIndexCampusId: '代理商ID',
  sampleIndexCampusName: '代理商名称',
  sampleIndexModelName: '商品名称',
  sampleIndexLimitCnt: '当前可用样机指标',
  sampleIndexPurchaseOwnCnt: '采购设备获得样机指标',
  sampleIndexActivityOwnCnt: '活动获得样机指标',
  sampleIndexUseCnt: '已使用样机指标',
  placeholderSampleModel: '请输入商品型号',

  // 开票数量小数说明（table 帮助弹窗）
  // 支付弹窗 PaymentDialog / CashRechargeDialog
  payConfirmTip: '本次支付将扣除：',
  fissionBonusAccount: '裂变奖金账户：',
  promoteAccount: '推广费账户：',
  cashAccount: '现金账户：',
  goldAccountPayConfirm: '金账户：',
  deliveryVoucherAccount: '提货券帐户：',
  payAmountDisplay: '支付￥{money}',
  paySuccessAmount: '成功支付￥{money}元',
  payFailedAmount: '未能成功支付￥{money}元',
  paySuccessTitle: '支付成功',
  payFailedTitle: '支付失败',
  cashRechargeTitle: '现金账户充值',
  rechargeAmountLabel: '充值金额：',
  placeholderRechargeAmount: '请输入充值金额',
  paymentMethodLabel: '付款方式：',
  publicTransfer: '对公转账',
  immediateRecharge: '立即充值',
  scanAlipay: '使用支付宝扫一扫',
  scanWechat: '使用微信扫一扫',
  qrCodeInvalid: '二维码地址不正确',
  qrCodeGenerating: '二维码生成中...',
  payAmountYuan: '支付{amount}元',
  rechargeSuccess: '充值成功',
  done: '完成',
  orderNoLabel: '采购单号：',
  ladingNoLabel: '提货单号：',
  freightLabel: '运费：',
  orderCreateTimeLabel: '下单时间：',
  purchaseQtyLabel: '采购量：',
  purchaseAmountLabel: '采购金额：',
  includeFreight: '（含运费：{amount}元）',
  receivedAmountLabel: '实付金额：',
  relatedAgentLabel: '关联代理商：',
  accountBalanceLabel: '账户余额：',
  procureAgentBalance: '采购代理商余额：',
  maxDeductibleLabel: '最高可抵扣：',
  remainingPayAmountLabel: '剩余支付金额：',
  deliveryVoucherAccountLabel: '提货券账户：',
  relatedAgentAccountBalance: '关联代理账户余额',
  accountBalance: '账户余额',

  invoiceQuantityDecimalQ: 'Q：为什么开票数量有是小数？',
  invoiceQuantityDecimalA: 'A：货款类的提现金额是下级经销商的订货款转入代理商提现账户的钱，松鼠已经向经销商的订单开过销售发票了，因此这个货款再被提现出来，要根据原始的订单对应商品型号、单价、金额红冲发票或反向开销售发票给松鼠，根据本次申请提现的金额用到不同订单的货款，会生成对应不同金额的开票信息，金额、单价固定的情况下，数量就是小数了',
};
